import axios from 'axios';
import Store from '../reducers';
const expired = 'TokenExpiredError';

export const CancelToken = axios.CancelToken;
export let cancelList;
export let cancelGetTypes;
export let cancelListConver;
export let cancelGetUnreadMessages;
export let cancelGetNewMessages;

export const getParticipants = async (conversation, all) => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/conversations/get-participants`, { conversation, all });
    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    throw err;
  }
};

export const getFiles = async (conversation) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/conversations/get-files/${conversation}`);
    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    throw err;
  }
};

export const countUnread = async () => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/conversations/count-unread`);
    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    throw err;
  }
};

export const getMyConversations = async (options) => {
  const { sort, direction, filters, offset, limit, search } = options;
  const body = { sort, direction, filters, search };

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/inbox?limit=${limit}&offset=${offset}`,
      body,
      { cancelToken: new CancelToken(function executor(c) { cancelListConver = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    throw err;
  }
};

export const sendDraftMessage = async (message, files) => {
  Store.dispatch({ type: 'LOADING' });
  let formData = new FormData();

  for (let key in message) {
    if (Array.isArray(message[key])) {
      message[key].forEach((item) => {
        formData.append(`${key}[]`, JSON.stringify(item));
      });
    } else {
      formData.append(key, message[key]);
    }
  }

  if (files.length > 0) {
    files.forEach(file => {
      formData.append('files', file);
    });
  }

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/send-draft-message`,
      formData,
      { cancelToken: new CancelToken(function executor(c) { cancelGetTypes = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    return err.response.data;
  } finally {
    Store.dispatch({ type: 'LOADED' });
  }
};

export const editConversation = async (conversation, body) => {
  Store.dispatch({ type: 'LOADING' });
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/edit-conversation/${conversation}`,
      body,
      { cancelToken: new CancelToken(function executor(c) { cancelGetTypes = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    return err.response.data;
  } finally {
    Store.dispatch({ type: 'LOADED' });
  }
};

export const sendDraft = async (data, files) => {
  Store.dispatch({ type: 'LOADING' });
  let formData = new FormData();

  for (let key in data) {
    if (Array.isArray(data[key])) {
      data[key].forEach((item) => {
        formData.append(`${key}[]`, key === 'attachments' ? JSON.stringify(item) : item);
      });
    } else {
      formData.append(key, data[key]);
    }
  }

  if (files.length > 0) {
    files.forEach(file => {
      formData.append('files', file);
    });
  }

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/send-draft-conversation`,
      formData,
      { cancelToken: new CancelToken(function executor(c) { cancelList = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    throw err;
  } finally {
    Store.dispatch({ type: 'LOADED' });
  }
};

export const getDraftEmail = async (id) => {
  Store.dispatch({ type: 'LOADING' });
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/conversations/get-draft-conversation/${id}`,
      { cancelToken: new CancelToken(function executor(c) { cancelList = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    throw err;
  } finally {
    Store.dispatch({ type: 'LOADED' });
  }
};

export const getScheduledMessage = async (conversation, message) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/get-scheduled-message`,
      { conversation, message },
      { cancelToken: new CancelToken(function executor(c) { cancelList = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    throw err;
  }
};

export const getMessages = async (conversation, page) => {
  Store.dispatch({ type: 'LOADING' });
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/get-messages/`,
      { conversation, page },
      { cancelToken: new CancelToken(function executor(c) { cancelList = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    throw err;
  } finally {
    Store.dispatch({ type: 'LOADED' });
  }
};

export const getContactsList = async name => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/contacts-list`,
      { name },
      { cancelToken: new CancelToken(function executor(c) { cancelGetTypes = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    return err.response.data;
  }
};

export const createConversation = async (data, files) => {
  Store.dispatch({ type: 'LOADING' });
  let formData = new FormData();

  for (let key in data) {
    if (Array.isArray(data[key])) {
      data[key].forEach((item) => {
        formData.append(`${key}[]`, key === 'attachments' ? JSON.stringify(item) : item);
      });
    } else {
      formData.append(key, data[key]);
    }
  }

  if (files.length > 0) {
    files.forEach(file => {
      formData.append('files', file);
    });
  }

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/create`,
      formData,
      { cancelToken: new CancelToken(function executor(c) { cancelGetTypes = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    return err.response.data;
  } finally {
    Store.dispatch({ type: 'LOADED' });
  }
};

export const createMessage = async (conver, message, files) => {
  Store.dispatch({ type: 'LOADING' });
  let formData = new FormData();

  for (let key in message) {
    if (Array.isArray(message[key])) {
      message[key].forEach((item) => {
        formData.append(`${key}[]`, JSON.stringify(item));
      });
    } else {
      formData.append(key, message[key]);
    }
  }

  if (files.length > 0) {
    files.forEach(file => {
      formData.append('files', file);
    });
  }

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/reply/${conver}`,
      formData,
      { cancelToken: new CancelToken(function executor(c) { cancelGetTypes = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    return err.response.data;
  } finally {
    Store.dispatch({ type: 'LOADED' });
  }
};

export const unreadMails = async id_arr => {
  Store.dispatch({ type: 'LOADING' });
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/markAsUnread`,
      { id_arr },
      { cancelToken: new CancelToken(function executor(c) { cancelGetTypes = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    return err.response.data;
  } finally {
    Store.dispatch({ type: 'LOADED' });
  }
};

export const readMails = async id_arr => {
  Store.dispatch({ type: 'LOADING' });
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/markAsRead`,
      { id_arr },
      { cancelToken: new CancelToken(function executor(c) { cancelGetTypes = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    return err.response.data;
  } finally {
    Store.dispatch({ type: 'LOADED' });
  }
};

export const restoreMails = async id_arr => {
  Store.dispatch({ type: 'LOADING' });
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/restore`,
      { id_arr },
      { cancelToken: new CancelToken(function executor(c) { cancelGetTypes = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    return err.response.data;
  } finally {
    Store.dispatch({ type: 'LOADED' });
  }
};

export const deleteMails = async (id_arr, erase) => {
  Store.dispatch({ type: 'LOADING' });
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/delete/`,
      { id_arr, erase },
      { cancelToken: new CancelToken(function executor(c) { cancelGetTypes = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    return err.response.data;
  } finally {
    Store.dispatch({ type: 'LOADED' });
  }

};
export const starMail = async (id, starred) => {
  Store.dispatch({ type: 'LOADING' });
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/star/${id}`,
      { starred },
      { cancelToken: new CancelToken(function executor(c) { cancelGetTypes = c; }) }
    );

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    return err.response.data;
  } finally {
    Store.dispatch({ type: 'LOADED' });
  }
};

export const deleteMessage = async id => {
  Store.dispatch({ type: 'LOADING' });
  try {
    const res = await axios.delete(`${process.env.REACT_APP_API_URL}/conversations/message/delete/${id}`);

    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    return err.response.data;
  } finally {
    Store.dispatch({ type: 'LOADED' });
  }
};

export const getUnreadMessages = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/conversations/unread-messages?`,
      { cancelToken: new CancelToken(function executor(c) { cancelGetUnreadMessages = c; }) }
    );
    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    throw err;
  }
};

export const getNewMessages = async (conver, time) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/conversations/new-messages/${conver}?time=${time || ''}`,
      { cancelToken: new CancelToken(function executor(c) { cancelGetNewMessages = c; }) }
    );
    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    throw err;
  }
};

export const muteConversations = async (id, mute = true) => {
  Store.dispatch({ type: 'LOADING' });
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/conversations/muteConversation`,
      { id, mute },
      { cancelToken: new CancelToken(function executor(c) { cancelGetTypes = c; }) }
    );
    return res.data;
  } catch(err) {
    if (err.response && err.response?.data?.message?.name === expired) {
      Store.dispatch({ type: 'LOGOUT' });
    }
    return err.response.data;
  } finally {
    Store.dispatch({ type: 'LOADED' });
  }
};

